import React, { FunctionComponent } from 'react';
import moment from 'moment';
import clsx from 'clsx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
    faMedal,
    faWallet,
    faBadgeDollar,
    faStar,
    faLaptop,
    faSyringe,
    faCakeCandles,
    faBellConcierge
} from '@fortawesome/pro-regular-svg-icons';
import { RewardsActivity, RewardsActivityIcon } from '@spike/loyalty-model';
import styles from './ActivityRow.module.scss';

export interface ActivityRowProps {
    activity: RewardsActivity;
}

// Matches the icon codification used for earning rules in Marketing/Loyalty/const.
const iconByKey: Record<RewardsActivityIcon, IconDefinition> = {
    'purchase': faBadgeDollar,
    'review': faStar,
    'booking': faLaptop,
    'vaccine': faSyringe,
    'pet-birthday': faCakeCandles,
    'total-bookings': faBellConcierge,
    'conversion': faWallet,
    'default': faMedal
};

const ActivityRow: FunctionComponent<ActivityRowProps> = ({ activity }) => {
    const isConversion = activity.type === 'conversion';
    const label = activity.petName ? `${activity.label} - ${activity.petName}` : activity.label;
    const conversionText = `${activity.points} pts → $${(activity.walletCreditValue ?? 0).toFixed(2)} Wallet Credit`;

    return (
        <div className={styles.row}>
            <div className={styles.icon}>
                <FontAwesomeIcon icon={iconByKey[activity.icon]} />
            </div>

            <div className={styles.details}>
                <p className={styles.label}>{label}</p>
                <p className={styles.date}>{moment(activity.date).format('MMM D, YYYY')}</p>
            </div>

            {isConversion ? (
                <div className={styles.conversionValue}>{conversionText}</div>
            ) : (
                <div className={clsx(styles.value, styles.earning)}>{`${activity.points < 0 ? '' : '+'}${
                    activity.points
                } pts`}</div>
            )}
        </div>
    );
};

export default ActivityRow;
